
import { TranslationRecord } from '../../types';

export const gallery: TranslationRecord = {
  // Gallery tabs
  all: 'Όλα',
  living: 'Καθιστικό',
  bedroom: 'Υπνοδωμάτιο',
  bathroom: 'Μπάνιο',
  kitchen: 'Κουζίνα',
  dining: 'Τραπεζαρία',
  exterior: 'Εξωτερικό',
  
  // Gallery actions
  viewImage: 'Προβολή Εικόνας',
  closeGallery: 'Κλείσιμο φωτογραφιών',
  previousImage: 'Προηγούμενη εικόνα',
  nextImage: 'Επόμενη εικόνα',
  
  // Error states
  errorLoadingGallery: 'Σφάλμα Φόρτωσης Φωτογραφιών',
  galleryErrorMessage: 'Αντιμετωπίσαμε ένα πρόβλημα κατά τη φόρτωση των φωτογραφιών της σουίτας. Παρακαλώ δοκιμάστε ξανά.',
  
  // Booking states
  bookingRedirect: 'Ανακατεύθυνση στην Κράτηση',
  bookingRedirectMessage: 'Άνοιγμα συστήματος κρατήσεων σε νέα καρτέλα',
  bookingError: 'Σφάλμα Κράτησης',
  bookingErrorMessage: 'Δεν είναι δυνατό το άνοιγμα του συστήματος κρατήσεων. Παρακαλώ δοκιμάστε ξανά.',
};
